<template>
  <div @click="onClickToggle" class="toggle-login">
    <div :class="{ 'toggle-login-bg': true, on: value }">
      <div :class="{ 'toggle-login-switch': true, on: value }"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: Boolean,
  },
  methods: {
    onClickToggle() {
      this.$emit('input', !this.value)
    },
  },
}
</script>

<style lang="scss" scoped>
.toggle-login {
  cursor: pointer;
}

.toggle-login-bg {
  position: relative;
  display: flex;
  align-items: center;
  background-color: var(--f-cool-gray-2);
  border-radius: 17px;
  width: 32px;
  height: 16px;

  &.on {
    background-color: #ff6e68;
  }
}

.toggle-login-switch {
  width: 12px;
  height: 12px;
  background-color: white;
  border-radius: 12px;
  transition: transform 0.3s;
  transform: translateX(calc(32px - 14px));

  &.on {
    transform: translateX(1.3px);
  }
}
</style>
